import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "min-h-screen bg-slate-50 py-8 px-4" };
const _hoisted_2 = { class: "max-w-xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-200 p-6" };
const _hoisted_3 = {
    key: 0,
    class: "mt-6 text-slate-500"
};
const _hoisted_4 = {
    key: 1,
    class: "mt-6 p-3 rounded-lg bg-rose-50 text-rose-700 border border-rose-200"
};
const _hoisted_5 = {
    key: 2,
    class: "mt-6 space-y-4"
};
const _hoisted_6 = { class: "p-4 rounded-xl border border-slate-200 bg-slate-50" };
const _hoisted_7 = { class: "text-sm text-slate-600" };
const _hoisted_8 = { class: "font-semibold text-slate-900" };
const _hoisted_9 = {
    key: 0,
    class: "text-xs text-slate-500"
};
const _hoisted_10 = { class: "space-y-2" };
const _hoisted_11 = { class: "flex gap-2" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 0,
    class: "text-emerald-700 text-sm"
};
import { inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FeedbackPage',
    setup(__props) {
        const route = useRoute();
        const api = inject('apiClient');
        if (!api) {
            throw new Error('RestaurantApiClient not provided.');
        }
        const loading = ref(true);
        const submitting = ref(false);
        const error = ref('');
        const successMessage = ref('');
        const feedback = ref(null);
        const selectedRating = ref(0);
        const comment = ref('');
        const token = String(route.params.uuid || '');
        const loadFeedback = async () => {
            loading.value = true;
            error.value = '';
            const response = await api.getFeedbackRequest(token);
            if (response.status !== 'success') {
                error.value = response.message || 'Feedback-Link konnte nicht geladen werden.';
                loading.value = false;
                return;
            }
            feedback.value = response.data;
            if (feedback.value?.status === 'rated') {
                successMessage.value = 'Diese Bewertung wurde bereits abgegeben. Vielen Dank!';
            }
            const queryRating = Number(route.query.rating || 0);
            if (queryRating >= 1 && queryRating <= 5) {
                selectedRating.value = queryRating;
            }
            loading.value = false;
        };
        const submitFeedback = async () => {
            if (selectedRating.value < 1 || submitting.value)
                return;
            submitting.value = true;
            error.value = '';
            successMessage.value = '';
            const response = await api.submitFeedback(token, selectedRating.value, comment.value);
            if (response.status !== 'success') {
                error.value = response.message || 'Feedback konnte nicht gespeichert werden.';
                submitting.value = false;
                return;
            }
            successMessage.value = 'Vielen Dank für dein Feedback.';
            submitting.value = false;
        };
        onMounted(async () => {
            await loadFeedback();
            if (selectedRating.value > 0 && feedback.value?.status === 'pending') {
                await submitFeedback();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-2xl font-bold text-slate-900" }, "Dein Feedback", -1 /* CACHED */)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-slate-600 mt-1" }, " Hilf uns, den Service zu verbessern. ", -1 /* CACHED */)),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Feedback-Link wird geladen ..."))
                        : (error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1 /* TEXT */))
                            : (feedback.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(feedback.value.restaurantName), 1 /* TEXT */),
                                        _createElementVNode("p", _hoisted_8, _toDisplayString(feedback.value.productName || 'Deine Bestellung'), 1 /* TEXT */),
                                        (feedback.value.orderNumber)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Bestellung #" + _toDisplayString(feedback.value.orderNumber), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm font-medium text-slate-800" }, "Wie war deine Erfahrung?", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_11, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                                                return _createElementVNode("button", {
                                                    key: n,
                                                    type: "button",
                                                    class: _normalizeClass(["w-11 h-11 rounded-full border transition", n <= selectedRating.value ? 'bg-amber-100 border-amber-300 text-amber-600' : 'bg-white border-slate-300 text-slate-400 hover:text-amber-500']),
                                                    onClick: ($event) => (selectedRating.value = n)
                                                }, " ★ ", 10 /* CLASS, PROPS */, _hoisted_12);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-800 mb-1" }, "Kommentar (optional)", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                                            rows: "4",
                                            maxlength: "1500",
                                            class: "w-full rounded-xl border border-slate-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500",
                                            placeholder: "Was lief gut, was können wir besser machen?"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, comment.value]
                                        ])
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "w-full rounded-xl bg-indigo-600 text-white font-semibold py-3 disabled:bg-indigo-300",
                                        disabled: submitting.value || selectedRating.value < 1,
                                        onClick: submitFeedback
                                    }, _toDisplayString(submitting.value ? 'Sende Feedback ...' : 'Feedback senden'), 9 /* TEXT, PROPS */, _hoisted_13),
                                    (successMessage.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(successMessage.value), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
